import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import {currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {
    OvernightRentalFacilityReservation,
    ReserveAvailableStatusOvernight
} from '../ReserveAvailabilityOvernight'
import {Nullable} from '../../../app/TypeHelpers';

export const ReserveAvailabilityOvernightTable: React.FC<{
    statuses: ReserveAvailableStatusOvernight[]
    myReservations: OvernightRentalFacilityReservation[]
    reservationId: Nullable<number>
}> = props => {
    return (<>
        <StyledCalenderTable>
            <tbody>
            <StyledCalendarHeader>
                {
                    props.statuses.map((status, index) =>
                        <StyledCalendarHeaderTH key={index}>
                            {getDayOfWeek(status.date)}
                        </StyledCalendarHeaderTH>
                    )
                }
            </StyledCalendarHeader>
            <StyledCalendarHeaderTR>
                {
                    props.statuses.map((status, index) =>
                        <StyledCalendarHeaderTD key={index}>
                            <div>{formatSimpleDateWithoutYear(status.date)}</div>
                            <ReserveStatus
                                status={status}
                                myReservations={props.myReservations}
                                reservationId={props.reservationId}
                            />
                        </StyledCalendarHeaderTD>)
                }
            </StyledCalendarHeaderTR>
            </tbody>
        </StyledCalenderTable>
    </>)
}

const ReserveStatus: React.FC<{
    status: ReserveAvailableStatusOvernight,
    myReservations: OvernightRentalFacilityReservation[],
    reservationId: Nullable<number>
}> = props => {
    const statusDate = moment(props.status.date + MOMENT_SUFFIX_FOR_DATE)
    const isMyReservedDate = props.myReservations.some((reservation) => {
        const stayStartDate = moment(reservation.startDate + MOMENT_SUFFIX_FOR_DATE)
        const stayEndDate = stayStartDate.clone().add(reservation.stayCount, 'day')
        return (stayStartDate <= statusDate && statusDate < stayEndDate && reservation.id !== props.reservationId)
    })

    if (isMyReservedDate) {
        return <StyledReservationStatusMyReserveIcon>■</StyledReservationStatusMyReserveIcon>
    } else if (props.status.reserveAvailable) {
        return <StyledReservationStatusIcon>○</StyledReservationStatusIcon>
    }
    return <StyledReservationStatusIcon>×</StyledReservationStatusIcon>
}

function formatSimpleDateWithoutYear(date: string): string {
    return moment(date + MOMENT_SUFFIX_FOR_DATE).format('M/D')
}

function getDayOfWeek(date: string): string {
    return moment(date + MOMENT_SUFFIX_FOR_DATE).format('ddd')
}

const MOMENT_SUFFIX_FOR_DATE = 'T00:00:00Z'

const StyledCalenderTable = styled.table`
  padding: 0;
  border-spacing: 0;
  border-collapse: collapse;
  align-items: center;
  width: 100%;
  table-layout: fixed;
  ${currentMedia.greaterThan('pc')`
      max-width: 354px;
      min-width: 330px;
  `};
`

const StyledCalendarHeader = styled.tr`
  background-color: ${Colors.LightBlueBackground};
  font-size: ${FontSize.Small};
`

const StyledCalendarHeaderTH = styled.th`
  border: 1px solid ${Colors.AccentLight};
  color: ${Colors.AccentDark};
  text-align: center;
`

const StyledCalendarHeaderTR = styled.tr`
`

const StyledCalendarHeaderTD = styled.td`
  font-size: ${FontSize.Small};
  color: ${Colors.AccentDark};
  border: 1px solid ${Colors.AccentLight};
  text-align: center;
  padding: 5px 0 5px 0;
`

const StyledReservationStatusIcon = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
`

const StyledReservationStatusMyReserveIcon = styled(StyledReservationStatusIcon)`
  color: rgb(255, 210, 150);
`
